"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toTitleCase = void 0;
// Please keep it consistent with the frontend mixin
const toTitleCase = (str) => {
    const titledCase = str.replace(/\w+/g, (txt) => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase());
    // Specifically don't capitalize the possessive `'S` (as in `Margo'S`)
    return titledCase.replace(/\w'S(?=\s|$)/g, (txt) => txt.substr(0).toLowerCase());
};
exports.toTitleCase = toTitleCase;
